import React from 'react'

export const Vision = () => {
  return (
    <div>Vision</div>
  )
}
